<template>
    <div class="widget-time-frame">
        <slot name="frame-types" />
        <div
            v-if="componentTypeKey !== 'TimePeriod'"
        >
            <RedesignFormLabel
                :label="$t('widget.time.interval')"
                class="mb-2"
            />
            <component
                :is="componentType"
                v-model="timeModel"
                v-bind="$attrs"
            />
        </div>
        <div v-else>
            <component
                :is="componentType"
                v-model="timeModel"
                v-bind="$attrs"
                class=""
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { capitalizeFirstLetter } from '@/helpers/util'
import RedesignFormLabel from '@/components/RedesignBaseComponents/Form/RedesignFormLabel.vue'
import WidgetTimeAbsolute from '@/components/RedesignComponents/Widgets/Common/WidgetTime/WidgetTimeAbsolute.vue'
import WidgetTimeRelative from '@/components/RedesignComponents/Widgets/Common/WidgetTime/WidgetTimeRelative.vue'
import WidgetTimePeriod from '@/components/RedesignComponents/Widgets/Common/WidgetTime/WidgetTimePeriod.vue'
import { WidgetTime } from '@/types/dashboard'
import { useVModel } from '@vueuse/core'

const COMPONENTS = {
    TimeAbsolute: WidgetTimeAbsolute,
    TimeRelative: WidgetTimeRelative,
    TimePeriod: WidgetTimePeriod
}

const props = withDefaults(
    defineProps<{
        value: WidgetTime
        timeFrameType?: string
    }>(),
    {
        timeFrameType: 'relative'
    }
)
const emit = defineEmits([ 'input' ])

const timeModel = useVModel(props, 'value', emit, { eventName: 'input' })

const componentTypeKey = computed(() => {
    return 'Time' + capitalizeFirstLetter(props.timeFrameType) as keyof typeof COMPONENTS
})
const componentType = computed(() => {
    return COMPONENTS[componentTypeKey.value]
})
</script>
